<script>
import { mapGetters } from 'vuex'

import deepLink from '@mixins/deeplink.js'
import rappiUtils from '@mixins/utils.js'
import { countryDataActions, widgetActions } from '@state/helpers'

export default {
  components: {},
  mixins: [deepLink(), rappiUtils()],
  computed: {
    ...mapGetters('widgets', ['userEnv', 'articleBuilderBody', 'logsUserID']),
  },
  created() {
    this.initStore()
    this.getCountryData().then(({ data }) => {
      this.commitCountryData(data)
    })
  },
  methods: {
    ...countryDataActions,
    ...widgetActions,
    initStore() {
      const { country_code: countryCode, token } = this.$route.query
      this.commitUser({
        countryCode,
        token,
        os: this.getMobileOperatingSystem(),
      })
      this.commitParams(this.$route.params)
      this.commitQuery(this.$route.query)
    },
  },
}
</script>

<template>
  <div :class="[$style.container, $style.noselect]">
    <slot />
  </div>
</template>

<style lang="scss" module>
@import '@design';

.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.container {
  max-width: $size-content-width-max;
  min-height: 100vh;
  margin: 0 auto;
}
</style>
